import {menu} from "./partials/base/menu";
import {validateForm} from "./partials/base/validate-form";
import {tinySlider} from "./partials/base/carousel";
import {fixedMenu} from "./partials/base/fixed_menu";
import {aspect_ratio} from "./partials/base/aspect_ratio";
import {modalOpen} from "./partials/base/modal_menu";
import {helpers} from "./partials/base/helpers";

window.onload = function() {
    menu();
    tinySlider();
    validateForm();
    fixedMenu();
    modalOpen('form-register-popup','registro-popup');
    modalOpen('form-login-popup','login-popup');
    helpers();
    aspect_ratio('banner_home', 964, 452, true);
    aspect_ratio('banner_middle', 751, 446, true);
};
window.onresize = function () {
    fixedMenu();
    aspect_ratio('banner_home', 964, 452, true)
    aspect_ratio('banner_middle', 751, 446, true)
};
